var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"avatar",class:{
    round: !_vm.props.squared,
    'fit-image-contain': _vm.props.imageFit && _vm.props.imageFit === 'contain'
  }},[_c('img',{style:({
      width: _vm.props.size,
      height: _vm.props.height || _vm.props.size
    }),attrs:{"src":_vm.props.avatarUrl,"alt":_vm.props.altText}})])}
var staticRenderFns = []

export { render, staticRenderFns }